import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios";
import apiUrl from "../config/apiPath";
import config from "../config/config";
import moment from 'moment';

export const displayErrorString = (error) => {
  toast.configure({
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: false,
  })
  toast.error(error);
}
export const displayError = (error) => {
  toast.configure({
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: false,
  })
  if (error.response.status === 422) {
    // var row = [];
    // Object.keys(error.response.data.errors).forEach((key, i) => {
    //   row.push(error.response.data.errors[key][0]);
    // })
    // const Msg = ({ closeToast, toastProps }) => (
    //   row.map((char, i) => {
    //     return (
    //       <li>
    //         {char}
    //       </li>
    //     );
    //   })
    // )
    toast.error(error.response.data.message);
  } else if (error.response.status === 400 || error.response.status === 401) {
    toast.error(error.response.data.message);
  } else {
    toast.error(error.message);
  }
}
export const displaySuccess = (success) => {
  toast.configure({
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: false,
  })
  toast.success(success);
}
export const getUsers = async () => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/get-users?limit=25&skip=0&search=&sort=desc`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getPhyios = async (limit = '', skip = '') => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/get-physios?limit=" + limit + "&skip=" + skip, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getPhyioKyc = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/view-physio-kyc/" + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getCoupons = async (limit = '', skip = '') => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/get-coupons?limit=" + limit + "&skip=" + skip, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getCouponById = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/coupon-details/" + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const exportPhysio = async (data) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + "/export-verified-physios", data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const exportUnverifiedPhysio = async (data) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + "/export-unverified-physios", data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const exportUser = async (data) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + "/export-users", data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const dashCounts = async (data) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/dashboard", {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getSpecialties = async (limit = '', skip = '') => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/get-specialties?limit=" + limit + "&skip=" + skip, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getInterests = async (limit = '', skip = '') => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/get-interests?limit=" + limit + "&skip=" + skip, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getPredefinedMessages = async (limit = '', skip = '') => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/predefined-message?limit=" + limit + "&skip=" + skip, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getSpecialtyById = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/specialty-details/" + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getInterestById = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/interest-details/" + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getPredefinedMsgById = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/predefined-message-details/" + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getAllTransactions = async (limit = '', skip = '') => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/all-transactions?limit=" + limit + "&skip=" + skip, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getBookings = async (limit = '', skip = '', user_id = '', physio_id = '', booking_status = 'all', from_date = '', to_date = '') => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + `/all-bookings`, {
    limit: limit,
    skip: skip,
    user_id: user_id,
    physio_id: physio_id,
    booking_status: booking_status,
    from_date: from_date == moment(new Date()).format('YYYY-MM-DD') ? '' : from_date,
    to_date: to_date == moment(new Date()).format('YYYY-MM-DD') ? '' : to_date
  }, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getCancelBooking = async (limit = '', skip = '') => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/cancelled-bookings", {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getRefund = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/refund-payment/" + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getVerifiedPhyios = async (limit = '', skip = '', search = '', banStatus = '', role = '', sort = "") => {
  const data = {
    // + limit + "&offset=" + skip + "&search=" + search
    limit: limit,
    offset: skip,
    sort: sort, //asc, desc
    search: search,
    is_banned: banStatus, //true, false, ""
    doctor_interest: role
  }
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + "/get-verified-physios", data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getUnverifiedPhyios = async (limit = '', skip = '', search = '', kycStatus = '', banStatus = '', role = '', sort = "") => {
  const data = {
    limit: limit,
    offset: skip,
    sort: sort, //asc, desc
    kyc: kycStatus,
    search: search,
    is_banned: banStatus, //true, false, ""
    doctor_interest: role
  }
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + "/get-unverified-physios", data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getUserDetail = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/user-details/" + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getPhysioDetail = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/physio-details/" + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getEscrowList = async (data) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + "/escrow-list/previous-week", data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getEscrowDetail = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/physio-escrow-sessions/previous-week/" + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}
export const getEscrowDetailForecast = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/physio-escrow-sessions/" + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}

export const getEscrowForecast = async (data) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + "/escrow-list", data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}

export const getInterestsDropdown = async () => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/get-services", {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}

export const getReportedUsers = async (limit = '', skip = '', search = '', sort = "") => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  const data = {
    limit: limit,
    skip: skip,
    search: search,
    sort: sort
  }
  var response_final = await axios.post(path + "/reported-users", data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}

export const getReportedPhysio = async (limit = '', skip = '', search = '', sort = "") => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  const data = {
    limit: limit,
    skip: skip,
    search: search,
    sort: sort
  }
  var r
  var response_final = await axios.post(path + "/reported-doctors", data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}

export const reportAction = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/action-taken/" + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}

export const sessionList = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/booking-sessions/` + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      console.log(response, "lpl")
      return response.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const walletPhysioList = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/wallet/physios-list`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const getProviderWallets = async (limit = '', skip = '', user_id = []) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + `/physio-wallets`, {
    limit: limit,
    skip: skip,
    user_ids: user_id,
  }, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}


export const WalletTransactions = async (id, limit, skip) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/wallet-transactions/${id}?limit=${limit}&skip=${skip}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}


export const physioPayouts = async (limit, skip, status) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/physio-payouts?limit=${limit}&skip=${skip}&status=${status}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const getAllTickets = async (page, perPage, sort, status) => {
  let path = config.walletService;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/tickets?page=${page}&per_page=${perPage}&sort=created_at.${sort}&status=${status}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const ticketResolved = async (id) => {
  let path = config.walletService;
  var token = localStorage.getItem('token');
  var data = {
    status: 'resolved'
  }
  var response_final = await axios.patch(path + `/tickets/` + id, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}


export const getAdmins = async (count, page) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  const data = {
    count: count,
    page: page
  }
  var response_final = await axios.post(path + `/admins-list`, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const getAdminDetail = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/admin-details/${id}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}
export const deleteAdmin = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/delete-admin/${id}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const authme = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/authme`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      if (error.response.status == 401) {
        localStorage.removeItem("token");
        window.location.href = '/'
      } else {
        console.log(error.response, "perrroorrr")
      }
      return [];
    })
  return response_final;
}

export const getNriInterest = async (type = "") => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/get-services`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    params: type ? { type } : {},
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const getNriProviders = async (count, page, search, status) => {
  let path = config.siteUrl;
  const data = {
    count: count,
    page: page,
    search: search || '',
    status: status || 'all'
  }
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + `/providers-list`, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const getNriDetails = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/provider-details/${id}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const getNriBookings = async (count, page, search, status) => {
  let path = config.siteUrl;
  const data = {
    count: count,
    page: page,
    search: search || '',
    status: status || 'all'
  }
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + `/all-bookings`, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const sendExtraPaymentRequest = async (booking_id, reason, amount) => {
  let path = config.siteUrl;
  const data = {
    booking_id: booking_id,
    reason: reason,
    amount: amount
  }
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + `/send-extra-payment-request`, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
  return response_final;
}

export const getExtraPayments = async (count, page, search, status) => {
  let path = config.siteUrl;
  const data = {
    count: count,
    page: page,
    search: search || '',
    status: status || 'all'
  }
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + `/all-extra-payments`, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const cancelExtraPaymentRequest = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/cancel-extra-payment-request/${id}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
  return response_final;
}

export const getProviderByInterest = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/get-providers-by-service/${id}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const getCouponList = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/get-coupons`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}
export const getFaqList = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/faqs-list`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}
export const editFaq = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/edit-faq/` + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const getNriCouponById = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/coupon-details/" + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}

export const getNriBookingById = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/booking-details/" + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}

export const removeSlots = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/delete-booking-slot/" + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}

export const getNriUsers = async (count, page, journey_status = '', search = '', gender = '') => {
  let path = config.siteUrl;
  const data = { count, page };
  if (journey_status) data.journey_status = journey_status;
  if (search) data.search = search;
  if (gender && gender !== 'all') data.gender = gender;
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + `/users-list`, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const dashCountsNri = async (data) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/dashboard", {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}

export const getMedicalList = async (data) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/get-service-conditions", {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}

export const getNriUserDetails = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/user-details/" + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}

export const getHospitalAdmins = async (count, page) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  const data = {
    count: count,
    page: page
  }
  var response_final = await axios.post(path + `/get-hospital-admins`, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const getHospitalProviders = async (count, page) => {
  let path = config.siteUrl;
  const data = {
    count: count,
    page: page
  }
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + `/hospital/providers-list`, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}


export const getHospitalDetails = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/hospital/provider-details/${id}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const getSurveys = async (count, page, search) => {
  const data = {
    count: count,
    page: page,
    search: search
  }
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + `/hospital/survey-list`, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const getSurveyDetail = async (id) => {

  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/hospital/survey-details/${id}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const exportSurvey = async (data) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/hospital/export-survey-list", {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}

export const getChannelPartners = async (count, page) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  const data = {
    count: count,
    page: page
  }
  var response_final = await axios.post(path + `/get-channel-partners`, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}


export const getChannelProviders = async (count, page) => {
  let path = config.siteUrl;
  const data = {
    count: count,
    page: page
  }
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + `/channel-partner/providers-list`, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const getChannelDetails = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/channel-partner/provider-details/${id}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const getChannelPartnerDropdown = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/get-channel-partners-dropdown`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const getChannelBookings = async (count, page) => {
  let path = config.siteUrl;
  const data = {
    count: count,
    page: page
  }
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + `/channel-partner/assigned-bookings`, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const getChannelProviderDropdown = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/channel-partner/providers-dropdown-list`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const getGynacList = async (count, page) => {
  let path = config.siteUrl;
  const data = {
    count: count,
    page: page
  }
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + `/gynac-list`, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const approveReject = async (id, status) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/gynac/${id}/${status}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const getAssessList = async (count, page) => {
  let path = config.siteUrl;
  const data = {
    count: count,
    page: page
  }
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + `/visit-forms-list`, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const getAssessmentHistory = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/visit-form-details/" + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}

export const getChecklistCategory = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + "/get-checklist-categories", {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return [];
    })
  return response_final;
}


export const getProviderList = async (count, page,) => {
  let path = config.siteUrl;
  const data = {
    count: count,
    page: page,
    // service_id: type
  }
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + `/yoga-trainers-list`, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}


export const getPediacList = async (count, page,) => {
  let path = config.siteUrl;
  const data = {
    count: count,
    page: page,
    // service_id: type
  }
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + `/pediatrician-list`, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const getReservations = async (count, page, search, status) => {
  let path = config.siteUrl;
  const data = {
    count: count,
    page: page,
    search: search || '',
    status: status || 'all'
  }
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + `/all-reservations`, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}

export const deleteReservation = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  return axios.get(path + `/delete-reservation/` + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  });
}
export const getServicesList = async () => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/get-services`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return { data: [] };
    })
  return response_final;
}

export const addService = async (formData) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  return axios.post(path + `/add-service`, formData, {
    headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${token}` }
  });
}

export const updateService = async (id, formData) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  return axios.post(path + `/update-service/` + id, formData, {
    headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${token}` }
  });
}

export const deleteService = async (id) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  return axios.get(path + `/delete-service/` + id, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  });
}

export const getMaternityUserWeekTasks = async (userId) => {
  let path = config.siteUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/admin/users/${userId}/week-tasks`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return null;
    })
  return response_final;
}

export const deleteMaternityReport = async (userId, reportId) => {
  let path = config.maternityServiceUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.delete(path + `/admin/users/${userId}/reports/${reportId}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return null;
    })
  return response_final;
}

export const getMaternityUserOverview = async (userId) => {
  let path = config.maternityServiceUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/admin/users/${userId}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return null;
    })
  return response_final;
}

export const getMaternityUserReports = async (userId) => {
  let path = config.maternityServiceUrl;
  var token = localStorage.getItem('token');
  // console.log('toke is  ----------- ', token);
  
  var response_final = await axios.get(path + `/admin/users/${userId}/reports`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return null;
    })
  return response_final;
}

export const getMaternityUserAppointments = async (userId) => {
  let path = config.maternityServiceUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/admin/users/${userId}/appointments`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return null;
    })
  return response_final;
}

export const getMaternityUserTasks = async (userId) => {
  let path = config.maternityServiceUrl;
  var token = localStorage.getItem('token');
  var response_final = await axios.get(path + `/admin/users/${userId}/tasks`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return null;
    })
  return response_final;
}

export const getExpenses = async (count, page, search = "", sort = "", sortOrder = "") => {
  let path = config.siteUrl;
  const data = {
    count: count,
    page: page,
    search: search,
    sortBy: sort,
    sortOrder: sortOrder
  }
  var token = localStorage.getItem('token');
  var response_final = await axios.post(path + `/expenses-list`, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
  })
    .then(function (response) {
      return response.data.data;
    })
    .catch(function (error) {
      console.log(error, "perrroorrr")
      return [];
    })
  return response_final;
}